import AdmissionForm from './form/Admission.form';
import DocumentsForm from './form/Documents.form';
import EducationForm from './form/Education.form';
import ParentalForm from './form/Parental.form';
import PersonalForm from './form/Personal.form';
import SurveyForm from './form/Survey.form';

export const CANDIDATES_FORM = (role: 'STUDENT' | 'CANDIDATE', {admissionFacultyIDs}: any) => [
	{
		name: 'Անձնական տվյալներ',
		fields: PersonalForm,
		visibility: ['ADD', 'EDIT']
	},
	{
		name: 'Ծնողների տվյալներ',
		fields: ParentalForm,
		visibility: ['ADD', 'EDIT']
	},
	{
		name: 'Կրթություն',
		fields: EducationForm,
		visibility: ['ADD', 'EDIT']
	},
	{
		name: 'Հարցում',
		fields: SurveyForm,
		visibility: ['ADD', 'EDIT']
	},
	{
		name: 'Ընդունելություն',
		fields: AdmissionForm(role, {admissionFacultyIDs}),
		visibility: ['ADD', 'EDIT']
	},
	{
		name: 'Փաստաթղթեր',
		fields: DocumentsForm,
		visibility: ['ADD', 'EDIT']
	}
	// ...(role === 'STUDENT'
	// 	? [
	// 			{
	// 				name: 'Քննություններ',
	// 				fields: ExamsForm,
	// 				visibility: ['ADD', 'EDIT']
	// 			}
	// 	  ]
	// 	: [])
];
